import * as React from "react";
import { Pressable, StyleProp, StyleSheet, ViewStyle } from "react-native";
import _, { isUndefined } from "lodash";

import { View } from "../../components/Themed";
import ErrorComponent from "../../components/Error";
import Loading from "../../components/Loading";
import useListFamilies from "../../hooks/families/useListFamilies";
import FamilyList from "./FamilyList";
import FamilyListItem from "./FamilyListItem";
import { Family } from "../../types";

export interface FamilyInputProps {
  styles?: StyleProp<ViewStyle>;
  value: Family["id"];
  onChange: (value?: Family["id"]) => void;
  disabled?: boolean;
}

function FamilyInput({
  value,
  styles: stylesProp,
  onChange = _.noop,
  disabled,
}: FamilyInputProps) {
  const { data, isLoading, error, isError, isFetching } = useListFamilies();

  return (
    <View style={stylesProp}>
      <Loading loading={isLoading || isFetching}>
        <FamilyList
          families={data}
          renderItem={(props) => (
            <Pressable
              onPress={() => {
                const { id: familyId } = props.family;
                onChange(value == props.family.id ? undefined : familyId);
              }}
            >
              <View
                style={value == props.family.id ? styles.selected : undefined}
              >
                <FamilyListItem {...props} disabled={disabled} />
              </View>
            </Pressable>
          )}
        />
      </Loading>

      {isError && <ErrorComponent error={error} />}
    </View>
  );
}

const styles = StyleSheet.create({
  selected: {
    backgroundColor: "lightgrey",
  },
});

export default FamilyInput;
